import { render, staticRenderFns } from "./index-desk.vue?vue&type=template&id=13140650&scoped=true"
import script from "./index-desk.vue?vue&type=script&lang=js"
export * from "./index-desk.vue?vue&type=script&lang=js"
import style0 from "./index-desk.vue?vue&type=style&index=0&id=13140650&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13140650",
  null
  
)

export default component.exports